import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import Helmet from 'react-helmet';
import {
  logout,
  login,
  passwordRecovery,
  requestPasswordRecovery,
  toggleExpandSubMenu,
} from './actions';
import { loadHelp } from 'vx-commons/lib/actions';
import { createStructuredSelector } from 'reselect';
import {
  selectLoginRequired,
  selectUserData,
  selectMenu,
  selectHelp,
  selectLocationState,
  selectConfig,
} from 'vx-commons/lib/selectors';
import { Icon } from 'vx-ui-components';
import SideBar from '../../components/SideBar';
import Login from '../../components/Login';
import PasswordRecovery from '../../containers/PasswordRecovery';
import RequestPasswordRecovery from '../../containers/RequestPasswordRecovery';
import Breadcrumb from '../../components/Breadcrumb';
import UserBox from '../../components/UserBox';
import Growler from '../../containers/Notification';
import { Flex, Box } from 'reflexbox';
import 'vx-ui-components/lib/style.css';
import styles from './styles.css';
import ReactMarkdown from 'react-markdown/with-html';
import { handleAuth, kratosLogout } from './external_auth';
import { spinner } from 'vx-commons/lib/utils/icons';
import Old from './old';

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      help: 'closed',
      docked: true,
      online: navigator.onLine,
      auth: {
        loading: true,
        externalLogin: false,
      },
    };

    this.toggleMenu = this.toggleMenu.bind(this);
    this.toggleChildrenMenu = this.toggleChildrenMenu.bind(this);
  }

  componentDidMount() {
    window.addEventListener('online', () => {
      this.setState({ online: true });
    });

    window.addEventListener('offline', () => {
      this.setState({ online: false });
    });

    const { external_auth } = this.props.config;

    handleAuth({ publicKratosAPIUrl: external_auth != null ? external_auth.api : '' }).then(res => {
      this.setState({ auth: { loading: false, externalLogin: res.externalLogin } }, () => {
        if (res.externalLogin) {
          if (this.props.loginRequired) {
            this.props.handleLogin('', '');
          }
        }
      });
    });
  }

  componentWillMount() {
    var mql = window.matchMedia(`(min-width: 1090px)`);
    mql.addListener(this.mediaQueryChanged);
    this.setState({ mql: mql, docked: mql.matches });
  }

  componentWillUnmount() {
    this.state.mql.removeListener(this.mediaQueryChanged);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.setState({ help: 'closed' });
    }
  }

  mediaQueryChanged = () => {
    this.setState({ docked: this.state.mql.matches });
  };

  goToHome = () => {
    this.props.changeRoute('/d/homepage');
  };

  openHelpSection = () => {
    this.setState({ help: 'wiki' });
    // ask for the help page (look at routes.js)
    this.props.loadHelpPage(this.props.routes[this.props.routes.length - 1].help);
  };

  closeHelpSection = () => {
    this.setState({ help: 'closed' });
  };

  openProfile = () => {
    this.props.changeRoute('/account');
  };

  openAbout = () => {
    this.props.changeRoute('/about');
  };

  openSupport = () => {
    this.props.changeRoute('/tickets');
  };

  logout = () => {
    if (this.state.auth.externalLogin) {
      kratosLogout({ publicKratosAPIUrl: this.props.config.external_auth.api });
      return;
    }
    this.props.logout();
    this.props.changeRoute('/');
  };

  toggleChildrenMenu(item) {
    this.props.toggleSubMenu(item);
  }

  toggleMenu() {
    this.setState({ docked: !this.state.docked });
  }

  render() {
    const { online, auth } = this.state;
    const {
      config,
      loginRequired,
      userData,
      children,
      menu,
      location,
      routes,
      router,
    } = this.props;

    let menuListData;

    const vumatelProvider =
      config.name === 'vumatel' &&
      (userData.role === 'service_provider' || userData.role === 'service_provider_support');

    menuListData = [
      ...(!vumatelProvider && [
        {
          label: 'Tickets',
          action: this.openSupport,
          icon: 'mailalert',
        },
      ]),
      {
        label: 'About',
        action: this.openAbout,
        icon: 'info2',
      },
      {
        label: 'Account',
        action: this.openProfile,
        icon: 'usercircle',
      },
      {
        label: 'Logout',
        action: this.logout,
      },
    ];

    if (userData.role === 'installer_manager') {
      menuListData = [
        {
          label: 'About',
          action: this.openAbout,
          icon: 'info2',
        },
        {
          label: 'Account',
          action: this.openProfile,
          icon: 'usercircle',
        },
        {
          label: 'Logout',
          action: this.logout,
        },
      ];
    }

    if (auth.loading) {
      return spinner();
    }

    let noConnectionMsg;

    if (!online) {
      noConnectionMsg = (
        <div className={styles.offlineWrapper}>
          <div className={styles.offlineContainer}>
            <p>
              <b>NO INTERNET CONNECTION AVAILABLE</b>
            </p>
            <p>• Checking the network cables, modem and router</p>
            <p>• Reconnecting to Wi-Fi</p>
          </div>
        </div>
      );
    }

    if (location.pathname === '/request_password_recovery') {
      if (auth.externalLogin) {
        return <Old />;
      }
      return (
        <RequestPasswordRecovery
          submitRequestPasswordRecovery={this.props.handleRequestPasswordRecovery}
        />
      );
    }

    if (location.pathname === '/password_recovery') {
      if (auth.externalLogin) {
        return <Old />;
      }
      return <PasswordRecovery submitPasswordRecovery={this.props.handlePasswordRecovery} />;
    }

    if (loginRequired) {
      return (
        <div>
          <Login submitLogin={this.props.handleLogin} />
        </div>
      );
    }

    // Define the breadcrumb
    let crumbs = [];
    if (routes.find(route => route.path === '/d/:dash')) {
      // Dashboard route
      crumbs = [
        router
          .getCurrentLocation()
          .pathname.replace(/\/d\//, '')
          .toUpperCase(),
      ];
    } else {
      // Page route
      const currentRoute = routes.find(route => {
        let currentLocation = router.getCurrentLocation().pathname.replace(/\/p\//, '');
        currentLocation =
          currentLocation.slice(-1) === '/' ? currentLocation.slice(0, -1) : currentLocation;

        const matched =
          route &&
          route.path &&
          route.path.indexOf(':') >= 0 &&
          Object.keys(this.props.params).length > 0;
        return matched || route.path === currentLocation;
      });

      if (currentRoute) {
        // In select mode the breadcrumb is replaced by a message like `SELECT OBJECT`
        crumbs =
          currentRoute.mode === 'select'
            ? [`>> ${currentRoute.name.toUpperCase()}`]
            : currentRoute.breadcrumb;
      }
    }

    return (
      <div>
        {noConnectionMsg}
        <Helmet
          titleTemplate="%s - VxAdmin"
          defaultTitle="Vx Admin"
          meta={[{ name: 'description', content: 'Vx Admin' }]}
        />
        <Growler />

        <div>
          <Flex className={styles.main}>
            <Box>
              <SideBar
                menu={menu}
                pathname={location.pathname}
                open={this.state.docked}
                toggle={this.toggleMenu}
                toggleChildrenMenu={this.toggleChildrenMenu}
              />
            </Box>

            <Flex column auto>
              <Flex pt={15} pr={25} pb={15} pl={20} mb={0}>
                <Box w={1 / 2}>
                  <Breadcrumb
                    data={crumbs}
                    userData={userData}
                    menuListData={menuListData}
                    openHelpSection={this.openHelpSection}
                    closeHelpSection={this.closeHelpSection}
                    help={this.state.help}
                    routes={routes}
                  />
                </Box>
                <Box w={1 / 2}>
                  <UserBox userData={userData} menuListData={menuListData} />
                </Box>
              </Flex>
              <Box className={styles.page}>{children}</Box>
              {// pluginHelp info box
              this.state.help !== 'closed' && (
                <div className={styles.pluginHelp}>
                  <Flex align="center">
                    <Box>
                      <button className={styles.closeButton} onClick={this.closeHelpSection}>
                        <Icon name="menu_close" stroke="#68689e" />
                      </button>
                    </Box>
                    {this.props.helpPage !== undefined ? (
                      <ReactMarkdown source={this.props.helpPage} escapeHtml={false} />
                    ) : (
                      <ReactMarkdown source="Loading Help..." />
                    )}
                  </Flex>
                </div>
              )}
            </Flex>
          </Flex>
        </div>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  helpPage: selectHelp('helppage'),
  locationState: selectLocationState(),
  loginRequired: selectLoginRequired(),
  userData: selectUserData(),
  menu: selectMenu(),
  config: selectConfig(),
});

function mapDispatchToProps(dispatch) {
  return {
    changeRoute: url => dispatch(push(url)),
    handleLogin: (username, password) => dispatch(login(username, password)),
    handleRequestPasswordRecovery: email => dispatch(requestPasswordRecovery(email)),
    handlePasswordRecovery: (password, recovery_code, email) =>
      dispatch(passwordRecovery(password, recovery_code)),
    logout: () => dispatch(logout()),
    loadHelpPage: help => dispatch(loadHelp(help, 'helppage')),
    toggleSubMenu: menuitem => dispatch(toggleExpandSubMenu(menuitem)),
  };
}

App.propTypes = {
  changeRoute: PropTypes.func,
  children: PropTypes.node,
  loginRequired: PropTypes.bool,
  userData: PropTypes.object,
  logout: PropTypes.func,
  routes: PropTypes.array.isRequired,
  menu: PropTypes.array,
  toggleSubMenu: PropTypes.func,
  config: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App/index.js